<template>
    <div>
        <model-edit :id="id"></model-edit>
    </div>
</template>

<script>
    import ModelEdit from '../../components/organizationalModel/ModelEdit';

    export default {
        components: {
            ModelEdit
        },
        props: {
            id: {
                required: true,
                type: Number
            },
        },
        data() {
            return {
                
            }
        },
        methods: {
            
        },
        mounted: function () {

        },
        computed: {
            
        }
    }
</script>

<style scoped>
</style>
